import React from 'react';
import styled from 'styled-components';
import Imagedata from "../../assets/images/plane.svg";

// Styled components
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; // full height of the viewport
  text-align: center;
  background-color: #f0f4f8;
`;


const Image = styled.img`
  max-width: 300px; // adjust as necessary
  max-height: 300px; // adjust as necessary
  margin-bottom: 24px;
`;

const Title = styled.h1`
  color: #000;
  margin-top: 20px;
`;

const Subtitle = styled.p`
  color: #555;
  margin-bottom: 20px;
`;

const BackButton = styled.button`
  padding: 10px 15px;
  border: none;
  background-color: #0000FF;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: #0000FR;
  }
`;

// React component
const ErrorPage = () => {
  return (
    <Container>
      <Image src={Imagedata} alt='No Result Found' />
      <Title>An Error Occurred</Title>
      <Subtitle>Oops! Aon unexpected error occurred. Our team is working to resolve it as soon as possible.</Subtitle>
    </Container>
  );
}

export default ErrorPage;
